import { Toast } from "primereact/toast";
import { useContext } from "react";
import "./App.css";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import { AppContext } from "./context/app-context";
import { DataProvider } from "./context/DataProvider";
import AppRoutes from "./routes/AppRoutes";

function App() {
  const { toast, toastCenter, toastTopCenter } = useContext(AppContext);
  return (
    <DataProvider>
      <ScrollToTop />
      <AppRoutes />
      <Toast ref={toast} />
      <Toast ref={toastCenter} position="center" />
      <Toast ref={toastTopCenter} position="top-center" />
    </DataProvider>
  );
}

export default App;
